export const AF_FIELD = 'data-af-field';
// Barra, e não ponto: 29 dos 48 painéis geram id de item com `Math.random()`, que produz float
// com ponto no meio. Trocar os ids não resolveria as páginas já publicadas, que têm o float
// salvo no JSON do S3.
export const SEGMENT_SEPARATOR = '/';
const isUsable = (segment) => segment !== null && segment !== undefined && String(segment).length > 0;
export const afField = (...segments) => segments.every(isUsable) ? segments.join(SEGMENT_SEPARATOR) : undefined;
export const parseAfField = (path) => path.split(SEGMENT_SEPARATOR);
export const isPrefixOf = (prefix, path) => path === prefix || path.startsWith(prefix + SEGMENT_SEPARATOR);
export const isValidSegment = (segment) => isUsable(segment) && !String(segment).includes(SEGMENT_SEPARATOR);
export const TOKEN_SEPARATOR = ' ';
export const afFieldGroup = (...paths) => {
    const usable = paths.filter((path) => isUsable(path));
    return usable.length > 0 ? usable.join(TOKEN_SEPARATOR) : undefined;
};
export const parseAfFieldGroup = (mark) => mark.split(/\s+/).filter(Boolean);
export const containerOwns = (mark, target) => isUsable(mark) && isUsable(target) && parseAfFieldGroup(mark).some((token) => isPrefixOf(token, target));
export const TOOLBAR_AVOID = 'data-toolbar-avoid';
export var ToolbarAvoid;
(function (ToolbarAvoid) {
    ToolbarAvoid["CONTENT"] = "content";
    ToolbarAvoid["ACTION"] = "action";
})(ToolbarAvoid || (ToolbarAvoid = {}));
export const parseToolbarAvoid = (value) => value === ToolbarAvoid.CONTENT || value === ToolbarAvoid.ACTION ? value : null;
